import { CloudPlaceholderProps } from './CloudPlaceholder.interface';
import { Placeholder } from '$uikit';
import { IcCloud28 } from '$assets';
import './CloudPlaceholder.sass';
import { FC } from 'react';

export const CloudPlaceholder: FC<CloudPlaceholderProps> = ({
  title,
  description,
  children,
}) => {
  return (
    <div className="Cloud__placeholder">
      <Placeholder centered>
        <IcCloud28 />
        <h2>{title}</h2>
        <p>{description}</p>
        {children}
      </Placeholder>
    </div>
  );
};
